import { render } from "./cross-icon.vue?vue&type=template&id=de1cccd0"
import script from "./cross-icon.vue?vue&type=script&lang=js"
export * from "./cross-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__